export const getGdsDisplayName = (gdsName: string): string => {
  if (gdsName === 'travel_port') return 'Travelport'

  if (gdsName === 'sabre') return 'Sabre'

  return gdsName
}
